import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import axios from "../../api/axios";

const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(amount);
};

function CheckoutForm({
  amount,
  sessionId,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) return;

    try {
      setIsProcessing(true);
      setErrorMessage("");

      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/payment-success`,
        },
        redirect: "if_required",
      });

      if (error) {
        setErrorMessage(error.message || "Payment failed.");
        return;
      }

      if (paymentIntent?.status === "succeeded") {
        await axios.post("/api/confirm-payment", {
          sessionId
        });

        setPaymentSuccess(true);


      } else {
        setErrorMessage("Payment was not completed. Please try again.");
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      setErrorMessage("Error processing the payment.");
    } finally {
      setIsProcessing(false);
    }
  };

  if (paymentSuccess) {
    return (
      <div className="rounded-xl border border-green-200 bg-green-50 p-5 text-green-700">
        <h3 className="text-lg font-bold">Payment successful</h3>
        <p className="mt-2">
          Thank you. Your invoice payment has been received.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="rounded-xl border border-slate-200 p-4">
        <PaymentElement />
      </div>

      <button
        type="submit"
        disabled={!stripe || !elements || isProcessing}
        className={`mt-4 w-full rounded-xl px-4 py-3 font-semibold text-white transition ${
          isProcessing
            ? "cursor-not-allowed bg-gray-400"
            : "bg-black hover:bg-gray-800"
        }`}
      >
        {isProcessing ? "Processing..." : `Pay ${formatCurrency(amount)}`}
      </button>

      {errorMessage && (
        <div className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700">
          {errorMessage}
        </div>
      )}
    </form>
  );
}

export default CheckoutForm;